jQuery(document).ready(function ($) {
    $('.count').counterUp({
        delay: 10,
        time: 3500
    });
});

jQuery(document).ready(function ($) {
    var animated = document.querySelector("#animated");
    var moreAboutOffer = document.querySelector("#moreAboutOffer");
    var waypoint = new Waypoint({
        element: document.querySelector(".box"),
        handler: function () {
            animated.classList.add("animated", "fadeInLeft");
            moreAboutOffer.classList.add("animated", "fadeInRight");
        }
    });
    var animatedAboutFirm = document.querySelector("#animationAboutFirm");

    var waypoint2 = new Waypoint({

        element: document.querySelector('.scrollDown'),
        handler: function () {
            animatedAboutFirm.classList.add("animated", "fadeIn");
            animatedAboutFirm.style = 'display:block';
        },
        offset: 240
    });

    var animateTeam = document.querySelector("#animateTeam");
    var waypoint3 = new Waypoint({

        element: document.querySelector('#aboutTeam'),
        handler: function () {
            animateTeam.classList.add("animated", "fadeInRight");
            animateTeam.style = 'display:block';
        },
        offset: 300
    });

    var $root = $('html, body');
    $('a').click(function () {
        $root.animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
        return false;
    });
    const height = $(window).height();
    const scrollTop = $(window).scrollTop();


    var $w = $(window),
        $canvases = $('body');
    var nav = document.querySelector("#nav");
    $w.scroll(function () {
        var d = $w.height() / 2 + $w.scrollTop();
        $canvases.each(function () {
            var $this = $(this),
                ptop = $this.offset().top,
                total = ptop + $this.height();
            if (d < 650) {
                nav.classList.remove("animated", "fadeIn", "navbar-fixed-top");

            }
            else {
                nav.classList.add("animated", "fadeIn", "navbar-fixed-top");
            }
            $this.toggleClass('active', ptop < d && total >= d);
        });
    }).scroll(); //trigger the handler when DOM is ready
});
